(function () {
    'use strict';

    angular
        .module('core.directives')
        .directive('onFileSelect', OnFileSelectDirective);

    /** @ngInject */
    function OnFileSelectDirective() {
        function link(scope, element) {
            element.bind('change', e => {
                const selectedFile = (e.srcElement || e.target).files[0];
                scope.onSelect(selectedFile)
                scope.$apply();
            });
        }

        return {
            link: link,
            restrict: 'AE',
            scope: {
                onSelect: '=onFileSelect'
            }
        }
    }
}());